import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DefaultFastTextField } from 'src/components/mui-overrides/Textfield';

interface Props {
  disabled?: boolean;
}

export const CarbonEmissionTextField: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();

  return (
    <DefaultFastTextField
      disabled={disabled}
      type="number"
      label={t('dashboard.assets.addedit.main.energydemand.carbonEmission.label')}
      fieldName="propertyDetails.carbonEmission"
    />
  );
};
